import styled from '@emotion/styled';

export const PopupWrapper = styled('div', { label: 'PopupWrapper' })`
   .popup {
       max-width: 1200px;
   }
`;

export const PropertiesList = styled('ul', { label: 'PropertiesList' })`
    padding-left: 15px;
`;

